import { useState } from "react"
import { Button, List, Tooltip, Typography,Avatar,Input } from "antd"
import { CheckOutlined, CheckSquareTwoTone } from "@ant-design/icons"
import moment from "moment"
import {
  submissionStatusOptions
} from "../../../../../../helpers/selectOptions/shared/submission-status"
import {
  getReadableValue
} from "../../../../../../helpers/selectOptions"
import { DeleteButton } from "../../../../../shared"
import PropTypes from "prop-types"
import React from "react"
import { apolloError } from "../../../../../../helpers/bugsnag/notify"
import { success } from "../../../../../../helpers"

CommentListing.propTypes = {
  comments: PropTypes.array,
  onDelete: PropTypes.func,
  onReview: PropTypes.func,
  readOnly: PropTypes.bool,
  revision: PropTypes.string,
  reviewed: PropTypes.array
}

const getCommentEntity = comment => {
  const entities = [
    "submission",
    "consultant",
    "beneficiary",
    "indicator",
    "concept",
    "humanResource",
    "specificObjective",
    "activity",
    "sustainabilityDetails",
    "beneficiaryParticipants",
    "projectMonthStatus",
    "financialStatementMonth"
  ]

  const entity = entities.find(key => comment[key])

  return entity
    ? {
        [entity]: comment[entity]
      }
    : {}
}

export function CommentListing ({
  comments,
  onSave,
  onDelete,
  onReview,
  readOnly,
  revision,
  reviewed: reviewedComments,
  mainproject = false,
  userAuthenticate
}) {
  const reviewedCommentsId = (reviewedComments || []).map(el => el.id)

  const [selectedCheckboxes, setSelectedCheckboxes] = useState({})
  const [replyingTo, setReplyingTo] = useState(null)
  const [reply, setReply] = useState("")
  const [expandedComments, setExpandedComments] = useState({})

  const readableRoles = {
    IMPLEMENTER: "IMPLEMENTADORA",
    ADMIN_AUDITOR: "ADMINISTRADOR"
  }

  const onCheckboxChange = ({ commentId }) => {
    setSelectedCheckboxes(prevState => ({
      ...prevState,
      [commentId]: !prevState[commentId]
    }))

    onReview({ id: commentId, reviewed: true })
  }

  const toggleReplies = commentId => {
    setExpandedComments(prevState => ({
      ...prevState,
      [commentId]: !prevState[commentId]
    }))
  }

  const startReply = commentId => {
    setReplyingTo(commentId)
    setReply("")
  }

  const cancelReply = () => {
    setReplyingTo(null)
    setReply("")
  }

  const saveReply = async comment => {
    if (!reply.trim()) {
      return
    }
    const newReply = {
      revision,
      type: comment.type,
      fieldName: comment.fieldName,
      comment: reply.trim(),
      userRol: userAuthenticate,
      createdAt: moment().format(),
      parentCommentId: comment.id,
      ...getCommentEntity(comment)
    }

    try {
      await onSave([newReply])

      setReplyingTo(null)
      setReply("")

      success("Respuesta guardada correctamente!")
    } catch (e) {
      apolloError(e)
    }
  }

  const renderComment = (comment, level = 0) => {
    const action = comment.revision === revision
      ? [
          <DeleteButton
            key="delete-btn"
            onClick={() => onDelete(comment)}
          />
        ]
      : []

    const hasReplies = comment.replies?.length > 0
    const isExpanded = expandedComments[comment.id]
    const isReplying = replyingTo === comment.id



    return (
      <React.Fragment key={comment.id}>
        <List.Item
          style={{
            paddingLeft: level * 30
          }}
          actions={action}>

          {mainproject ? (
            <List.Item.Meta
              style={{ paddingRight: "1.5rem" }}
              title={
                <Typography.Text type="secondary">
                  {comment.userRol} - {comment.User} -
                  <Typography.Text disabled>
                    {moment(comment.createdAt).format("DD MMMM YYYY")}
                  </Typography.Text>
                </Typography.Text>
              }
              description={
                <Typography.Text  style={{ fontWeight: "normal" }}>
                  {comment.comment}
                </Typography.Text>
              }
            />
          ) : (
            <List.Item.Meta
              title={
                <Typography.Text  style={{ fontWeight: "normal" }}>
                  {comment.comment}
                </Typography.Text>
              }
              description={
                <Typography.Text type="secondary">
                  {readableRoles?.[comment?.userRol] ??
                    getReadableValue(
                      submissionStatusOptions,
                      comment?.revision
                    )}
                  &nbsp;
                  -
                  &nbsp;
                  {moment(comment.createdAt).format("DD/MM/YYYY")}
                </Typography.Text>
              }
            />
          )}
            <Button
              type="link"
              onClick={() =>
                isReplying
                  ? cancelReply()
                  : startReply(comment.id)
              }>
              {isReplying ? "Cancelar" : "Responder"}
            </Button>

            {!comment.parentCommentId && (
            comment.reviewed ? (
              <Tooltip title="Solucionado">
                <CheckSquareTwoTone style={{ fontSize: 22 }} />
              </Tooltip>
            ) : (
              !readOnly && (
                <Tooltip title="¿Marcar como solucionado?">
                  <Button
                    type="validation"
                    style={{
                      background: selectedCheckboxes[comment.id]
                        ? "#2593FC"
                        : ""
                    }}
                    disabled={
                      comment.reviewed ||
                      reviewedCommentsId.includes(comment.id)
                    }
                    icon={
                      <CheckOutlined
                        style={{ color: "#85C1E9" }}
                      />
                    }
                    onClick={() => {
                      onCheckboxChange({
                        commentId: comment.id
                      })
                    }}
                    size="small"
                  />
                </Tooltip>
              )
            )
          )}
        </List.Item>

        {isReplying && (
          <div
            style={{
              marginLeft: (level + 1) * 30,
              marginBottom: 16
            }}>

            <Input.TextArea
              value={reply}
              onChange={event =>
                setReply(event.target.value)
              }
              placeholder="Escribe una respuesta..."
              rows={3}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                marginTop: 10,
                alignItems: "center",
              }}>
              <span onClick={cancelReply}
              style={{color: '#3D3C3C',cursor: 'pointer'}}>
                Cancelar
              </span>
              <Button
                type="primary"
                disabled={!reply.trim()}
                onClick={() => saveReply(comment)}>
                Enviar
              </Button>
            </div>
          </div>
        )}

        {hasReplies && (
          <>
            <Button
              type="link"
              onClick={() => toggleReplies(comment.id)}
              style={{
                marginLeft: (level + 1) * 30
              }}>
            </Button>

            {
              comment.replies.map(reply =>
                renderComment(reply, level + 1)
              )}
          </>
        )}
      </React.Fragment>
    )
  }

  const organizedComments = comments => {
    const commentsMap = new Map()
    const rootComments = []
  
    comments.forEach(comment => {
      commentsMap.set(comment.id, {
        ...comment,
        replies: []
      })
    })
  
    comments.forEach(comment => {
      if (comment.parentCommentId) {
        const parent = commentsMap.get(comment.parentCommentId)
  
        if (parent) {
          parent.replies.push(commentsMap.get(comment.id))
        }
      } else {
        rootComments.push(commentsMap.get(comment.id))
      }
    })
  
    rootComments.forEach(comment => {
      comment.replies.sort(
        (a, b) =>
          new Date(a.createdAt) - new Date(b.createdAt)
      )
    })
  
    return rootComments
  }

  const organized = organizedComments(comments || [])
  
  return (
    <List
    header={
      <Typography.Text>
        Comentarios ({comments?.length || 0})
      </Typography.Text>
    }>
    {organized?.map(comment =>
      renderComment(comment)
    )}
  </List>
  )
}